import {Component, Input} from '@angular/core';
import {IdName} from '@core/src/public-api';

@Component({
  selector: 'si-mtest-medical-test-item',
  templateUrl: './mtest-medical-test-item.component.html',
  styleUrls: ['./mtest-medical-test-item.component.scss']
})
export class MtestMedicalTestItemComponent {
  @Input() requestId: number;
  @Input() date: number;
  @Input() appointmentDate: number;
  @Input() canSchedule: boolean;
  @Input() centerName: string;
  @Input() serviceName: string;
  @Input() requestTypeName: string;
  @Input() requestTypeId: number;
  @Input() requestStateId: number;
  @Input() informedConsents: IdName[];
  @Input() actions: string[];
}
